import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";
import { FormCheckBlack } from "../features/RadConnStyle";

export default function CheckList(props) {
  const [data, setData] = props.data;

  const onValueChanged = (e) => {
    if (e.target.checked) {
      // add new
      setData((pv) => {
        let checkOld = pv.oldItems.filter(
          (r) => r.DocuTypeId === Number(e.target.value)
        );
        if (checkOld.length === 0) {
          let item = pv.allItems.filter(
            (r) => r.DocuTypeId === Number(e.target.value)
          );

          if (item.length > 0) {
            pv.oldItems = [
              ...pv.oldItems,
              {
                DocuType: { DocuTypeId: item[0].DocuTypeId },
                Branch: { BrchID: data.BrchID },
                DocuBrchId: 0,
                DelFlag: false,
              },
            ];
          }
        }

        return { ...pv };
      });
    } else {
      // remove old if exists or flags delelted

      setData((pv) => {
        let checkOld = pv.oldItems.filter(
          (r) => r?.Docutype?.DocuTypeId === Number(e.target.value)
        );

        if (checkOld.length > 0) {
          // รายการเก่า
          if (checkOld[0].DocuBrchId > 0) {
            pv.oldItems = [...pv.oldItems, { ...checkOld[0], DelFlag: true }];
            return { ...pv };
          }
        }
        pv.oldItems = pv.oldItems.filter(
          (r) => r?.DocuType?.DocuTypeId !== Number(e.target.value)
        );

        return { ...pv };
      });
    }
  };

  const checkOldItem = (value) => {
    let item = data?.oldItems.filter((r) => r.DocuType?.DocuTypeId === value);
    if (item.length > 0) {
      return true;
    }
    return false;
  };

  return (
    <DivCheckList>
      {data?.allItems?.map((item, i) => {
        let checked = checkOldItem(item?.DocuTypeId);
        return (
          <FormCheckBlack
            style={{ marginInline: "5px" }}
            label={item.DocuTypeName}
            checked={checked}
            value={Number(item.DocuTypeId)}
            onChange={onValueChanged}
          />
        );
      })}
    </DivCheckList>
  );
}

const DivCheckList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-block: 10px;
  padding-inline-start: 20px;
`;
